// extracted by mini-css-extract-plugin
export default {"notAvailableContainer":"LogSearchTable_notAvailableContainer__C3dk4"};